import { Button } from "../../utils/Utils";
import { GameVars } from "../../GameVars";
import { BoardManager } from "./BoardManager";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { Niche } from "./niche/Niche";
import { AudioManager } from "../../AudioManager";
import { BoardContainer } from "./BoardContainer";

export class GUI extends Phaser.GameObjects.Container {

    public static currentInstance: GUI;

    public static REROLL_BUTTON_POSITION = {x: 162, y: 418};
    public static SPIN_BUTTON_POSITION = {x: 162, y: 520};

    private static handCursorShownOnRerollButton = false;

    public updateAllowed: boolean;

    private reRollButton: Button;
    private spinButton: Button;
    private reRollButtonOffImg: Phaser.GameObjects.Image;
    private spinButtonOffImg: Phaser.GameObjects.Image;
    private reRollsLabel: Phaser.GameObjects.Text;
    private spinsLabel: Phaser.GameObjects.Text;
    private reRollsCircle: Phaser.GameObjects.Image;
    private spinsCircle: Phaser.GameObjects.Image;
    private handCursor: Phaser.GameObjects.Image;
    private reRollTutorialLabel: Phaser.GameObjects.Text;
    private spinTutorialLabel: Phaser.GameObjects.Text;
    private reRollTutorialLabelBackground: Phaser.GameObjects.Image;
    private spinTutorialLabelBackground: Phaser.GameObjects.Image;
    private spinDisabled: boolean;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        GUI.currentInstance = this;

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT * .45;

        this.scaleY = GameVars.scaleY;

        this.updateAllowed = false;
        this.handCursor = null;
        this.spinDisabled = false;

        const pauseButton = new Button(this.scene, -332, -402, "texture_atlas_3", "btn_menu_off", "btn_menu_on");
        pauseButton.onDown(this.onClickPauseMenu, this);
        this.add(pauseButton);  

        if (!GameVars.gameData.tutorialLabelsSeen) {

            this.reRollTutorialLabelBackground = new Phaser.GameObjects.Image(this.scene, GUI.REROLL_BUTTON_POSITION.x + 15, GUI.REROLL_BUTTON_POSITION.y - 19, "texture_atlas_1", "feature_tab");
            this.reRollTutorialLabelBackground.setOrigin(1, .5);
            this.add(this.reRollTutorialLabelBackground); 

            this.reRollTutorialLabel = new Phaser.GameObjects.Text(this.scene, this.reRollTutorialLabelBackground.x - 50, this.reRollTutorialLabelBackground.y - 2, "Re-roll Piece", {fontFamily: "Futura-Medium", fontSize: "20px", color: "#18293e"});
            this.reRollTutorialLabel.setOrigin(1, .5);
            this.add(this.reRollTutorialLabel);

            this.spinTutorialLabelBackground = new Phaser.GameObjects.Image(this.scene, GUI.SPIN_BUTTON_POSITION.x + 40, GUI.SPIN_BUTTON_POSITION.y + 20, "texture_atlas_1", "feature_tab");
            this.spinTutorialLabelBackground.setOrigin(1, .5);
            this.add(this.spinTutorialLabelBackground); 

            this.spinTutorialLabel = new Phaser.GameObjects.Text(this.scene, this.spinTutorialLabelBackground.x - 75, this.spinTutorialLabelBackground.y - 2, "Turn Piece", {fontFamily: "Futura-Medium", fontSize: "20px", color: "#18293e"});
            this.spinTutorialLabel.setOrigin(1, .5);
            this.add(this.spinTutorialLabel);

        } else {

            this.reRollTutorialLabel = null;
            this.spinTutorialLabel = null;
        }
       
        // REROLLS
        this.reRollButton = new Button(this.scene, GUI.REROLL_BUTTON_POSITION.x, GUI.REROLL_BUTTON_POSITION.y, "texture_atlas_2", "btn_reroll_on_off", "btn_reroll_on_on");
        this.reRollButton.onDown(this.onClickReRoll, this);
        this.add(this.reRollButton);

        this.reRollButtonOffImg = new Phaser.GameObjects.Image(this.scene, this.reRollButton.x, this.reRollButton.y, "texture_atlas_2", "btn_reroll_off_off");
        this.reRollButtonOffImg.visible = false;
        this.add(this.reRollButtonOffImg);

        this.reRollsCircle = new Phaser.GameObjects.Image(this.scene, 185, 390, "texture_atlas_1", "circle_items");
        this.reRollsCircle.visible = false;
        this.add(this.reRollsCircle);

        this.reRollsLabel = new Phaser.GameObjects.Text(this.scene, this.reRollsCircle.x, this.reRollsCircle.y, "3", {fontFamily: "Futura-Medium", fontSize: "23px", color: "#FFFFFF"});
        this.reRollsLabel.setOrigin(.5);
        this.reRollsLabel.visible = false;
        this.add(this.reRollsLabel);

        // ROTATIONS
        this.spinButton = new Button(this.scene, GUI.SPIN_BUTTON_POSITION.x, GUI.SPIN_BUTTON_POSITION.y, "texture_atlas_2", "btn_spin_on_off", "btn_spin_on_on");
        this.spinButton.onDown(this.onClickSpin, this);
        this.add(this.spinButton);

        this.spinButtonOffImg = new Phaser.GameObjects.Image(this.scene, this.spinButton.x, this.spinButton.y, "texture_atlas_2", "btn_spin_off_off");
        this.spinButtonOffImg.visible = false;
        this.add(this.spinButtonOffImg);

        this.spinsCircle = new Phaser.GameObjects.Image(this.scene, 185, 545, "texture_atlas_1", "circle_items");
        this.spinsCircle.visible = false;
        this.add(this.spinsCircle);

        this.spinsLabel = new Phaser.GameObjects.Text(this.scene, this.spinsCircle.x, this.spinsCircle.y, "3", {fontFamily: "Futura-Medium", fontSize: "23px", color: "#FFFFFF"});
        this.spinsLabel.setOrigin(.5);
        this.spinsLabel.visible = false;
        this.add(this.spinsLabel);

        if (GameConstants.DEVELOPMENT) {
            const forceGameOverButton = new Button(this.scene, -250, -402, "texture_atlas_1", "btn_x_off", "btn_x_on");
            forceGameOverButton.onDown(this.onClickForceGameOver, this);
            forceGameOverButton.setScale(.75, .75 * GameVars.scaleY);
            this.add(forceGameOverButton);
        }
    }

    public update(): void {

        if (!this.updateAllowed) {
            return;
        }

        if (GameVars.templokEngine.spins > 0) {

            this.spinButton.visible = true;
            this.spinButtonOffImg.visible = false;
            this.spinsLabel.visible = true;

            if (this.spinDisabled) {
                this.spinsLabel.text = "X";
                this.spinButton.visible = false;
                this.spinButtonOffImg.visible = true; 
            } else {
                this.spinButton.visible = true;
                this.spinButtonOffImg.visible = false;
                this.spinsLabel.text = GameVars.templokEngine.spins.toString();
            }

            this.spinsCircle.visible = true;

        } else {
            
            this.spinButton.visible = false;
            this.spinButtonOffImg.visible = true;
            this.spinsLabel.visible = false;
            this.spinsCircle.visible = false;
        }

        if (GameVars.templokEngine.reRolls > 0) {
            this.reRollButton.visible = true;
            this.reRollButtonOffImg.visible = false;
            this.reRollsLabel.visible = true;
            this.reRollsLabel.text = GameVars.templokEngine.reRolls.toString();
            this.reRollsCircle.visible = true;
        } else {
            this.reRollButton.visible = false;
            this.reRollButtonOffImg.visible = true;
            this.reRollsLabel.visible = false;
            this.reRollsCircle.visible = false;
        }
    }

    public deactivateSpin(): void {

        this.spinButton.disableInteractive();

        this.spinDisabled = true;
    }

    public activateSpin(): void {

        this.spinButton.setInteractive();

        this.spinDisabled = false;
    }

    public onGameStarted(): void  {

        this.updateAllowed = true;
    }

    public showHandCursorOnRerollButton(): void {

        if (this.handCursor || GUI.handCursorShownOnRerollButton) {
            return;
        }

        GUI.handCursorShownOnRerollButton = true;

        const x = this.reRollButton.x + 35;
        const y = -50;

        this.handCursor = new Phaser.GameObjects.Image(this.scene, x, y, "texture_atlas_1", "hand_cursor");
        this.handCursor.setOrigin(0);
        this.handCursor.angle = 30;
        this.handCursor.setScale(-.85, .85);
        BoardContainer.currentInstance.blocksDispenser.add(this.handCursor);

        this.scene.tweens.add({
            targets: this.handCursor,
            scaleX: -.8,
            scaleY: .8,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500,
            repeat: -1,
            yoyo: true
        });
    }

    public onClickReRoll(): void {

        if (GameVars.paused || GameVars.reRolling || GameVars.gameOver || Niche.currentInstance.block === null) {
            return;
        }

        if (this.reRollTutorialLabel) {

            this.reRollTutorialLabel.destroy();
            this.reRollTutorialLabel = null;

            this.reRollTutorialLabelBackground.destroy();
            this.reRollTutorialLabelBackground = null;

            if (!this.reRollTutorialLabel && !this.spinTutorialLabel) {
                GameManager.onTutorialLabelsSeen();
            }
        }

        this.reRollButton.visible = false;
        
        if (this.handCursor) {
            this.handCursor.destroy();
        }

        BoardManager.currentInstance.reRoll();
        
        AudioManager.playSound("btn_feature_pressed");
    }

    public onClickSpin(): void {

        if (GameVars.paused || GameVars.reRolling || GameVars.gameOver || Niche.currentInstance.block === null ) {
            return;
        }

        if (this.spinTutorialLabel) {
            
            this.spinTutorialLabel.destroy();
            this.spinTutorialLabel = null;

            this.spinTutorialLabelBackground.destroy();
            this.spinTutorialLabelBackground = null;

            if (!this.reRollTutorialLabel && !this.spinTutorialLabel) {
                GameManager.onTutorialLabelsSeen();
            }
        }

        BoardManager.currentInstance.rotate();
        
        AudioManager.playSound("btn_feature_pressed");
    }

    public onBoosterPurchased(): void {

        this.scene.tweens.add({
            targets: [this.reRollsCircle, this.reRollsLabel],
            scaleX: 1.35,
            scaleY: 1.35,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500,
            yoyo: true
        });
    }

    private onClickPauseMenu(): void {

        if (GameVars.paused || GameVars.gameOver) {
            return;
        }
        
        BoardManager.currentInstance.pauseGame();
    }

    private onClickForceGameOver(): void {

        if (GameVars.paused) {
            return;
        }

        BoardManager.currentInstance.onGameOver();

        AudioManager.playSound("btn_pressed");
    }
}
